import React from "react";

const Footer = () => {
  return (
    <footer className="bg-footer text-white py-5">
      <div className="container">
        <div className="row gy-5 align-items-stretch footer-row">
          <div className="col-md-4 footer-column">
            <h5>
              <img src="/assets/images/logo.png" className="logo" alt="logo" />
            </h5>
            <p className="about-footer">
              V_CAM est une entreprise engagée dans l’impact numérique local. Composée d’une équipe de
              passionnés, elle conçoit des solutions sur mesure, « made in Cameroun », pour accompagner
              les PME dans leur montée en puissance digitale avec professionnalisme et proximité.
            </p>
          </div>

          <div className="col-md-4 footer-column">
            <h5 className="title-footer">Nos réseaux sociaux</h5>
            <p className="footer-subtitle">
              Restez informés de nos innovations, offres et événements en suivant nos comptes officiels.
            </p>
            <div className="social-icons-col">
              <a
                href="https://web.facebook.com/profile.php?id=100071858223993"
                className="social-link text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="social-icon">
                  <i className="fab fa-facebook-f" aria-hidden="true"></i>
                </span>
                <div>
                  <div className="social-name">Facebook</div>
                  <small>Actualités & événements</small>
                </div>
              </a>
              <a
                href="https://youtube.com/@visibilitycam?si=Mz0_EXnJUAhHxJtZ"
                className="social-link text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="social-icon">
                  <i className="fab fa-youtube" aria-hidden="true"></i>
                </span>
                <div>
                  <div className="social-name">YouTube</div>
                  <small>Découvrir nos démonstrations</small>
                </div>
              </a>
              <a
                href="https://www.linkedin.com/company/visibility-cam-sarl/"
                className="social-link text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="social-icon">
                  <i className="fab fa-linkedin-in" aria-hidden="true"></i>
                </span>
                <div>
                  <div className="social-name">LinkedIn</div>
                  <small>Réseautage professionnel</small>
                </div>
              </a>
            </div>
          </div>

          <div className="col-md-4 footer-column">
            <h5 className="title-footer text-white ps-4">Contacts</h5>
            <ul className="list-unstyled contact">
              <li className="py-1 d-flex">
                <div className="mt-2">
                  <i className="fas fa-map-marker-alt text-white fs-4"></i>
                </div>
                <div>
                  <p className="mb-0 text-white ms-4">
                    Dschang, Cameroun
                    <br />
                    Douala, Cameroun
                  </p>
                </div>
              </li>
              <li className="py-3 d-flex">
                <div>
                  <i className="fas fa-clock text-white fs-4"></i>
                </div>
                <div>
                  <p className="mb-0 text-white ms-4">
                    Lun - Ven : 8h00 - 18h00
                    <br />
                    Sam : 8h00 - 13h00
                  </p>
                </div>
              </li>
              <li className="py-3 d-flex">
                <div className="mt-2">
                  <i className="fas fa-phone text-white fs-4"></i>
                </div>
                <div>
                  <p className="mb-0 text-white ms-4">
                    <a href="tel:+237698613243" className="text-white text-decoration-none">
                      +237 698 61 32 43
                    </a>
                    <br />
                    <a href="tel:+237697049654" className="text-white text-decoration-none">
                      +237 697 04 96 54
                    </a>
                  </p>
                </div>
              </li>
              <li className="py-3 d-flex">
                <div>
                  <i className="fas fa-envelope text-white fs-4"></i>
                </div>
                <div>
                  <p className="mb-0 text-white ms-4">
                    <a href="mailto:contact@visibilitycam.com" className="text-white text-decoration-none">
                      contact@visibilitycam.com
                    </a>
                    <br />
                    <a href="mailto:demo@visibilitycam.com" className="text-white text-decoration-none">
                      demo@visibilitycam.com
                    </a>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div className="row mt-3">
          <div className="col text-center">
            <p>&copy; {new Date().getFullYear()} V_CAM - Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
